import { APP_NAMES, type AppType } from '@common/core-layer/stores/global.store'

import type { ProfileMenuIconName } from '../types/profile-menu'

export const PROFILE_MENU_OPTIONS = {
  PROFILE_SETTINGS: 'profile-settings',
  ACCOUNT_SETTINGS: 'account-settings',
  MANAGE_PAYMENTS: 'manage-payments',
  KOLLAB_STUDIO: 'kollab-studio',
  AFFILIATES: 'affiliates',
  LOGOUT: 'logout',
} as const

export type ProfileMenuOption = 'profile-settings' | 'account-settings' | 'manage-payments' | 'kollab-studio' | 'affiliates' | 'logout'

/** Internal: use CPNavigateTo with route name. External: full navigation (path or absolute URL). */
export type ProfileMenuNavigation =
  | { type: 'internal'; name: string; query?: Record<string, string>; newTab?: boolean }
  | { type: 'external'; path: string; newTab?: boolean }

/**
 * Profile menu item configuration.
 * `showOnApps` restricts the item to specific apps. Include all `APP_NAMES` values to show everywhere.
 */
export const PROFILE_MENU_ITEMS: ReadonlyArray<{
  key: (typeof PROFILE_MENU_OPTIONS)[keyof typeof PROFILE_MENU_OPTIONS]
  labelKey: string
  icon: ProfileMenuIconName
  navigation: ProfileMenuNavigation
  showOnApps: ReadonlyArray<AppType>
}> = [
  {
    key: PROFILE_MENU_OPTIONS.PROFILE_SETTINGS,
    labelKey: 'profileMenu.profileSettings',
    icon: 'UserCircleIcon',
    navigation: { type: 'internal', name: 'account-settings', query: { activeTab: 'profile' } },
    showOnApps: [APP_NAMES.CLIENTPORTAL, APP_NAMES.GOKOLLAB, APP_NAMES.COURSES, APP_NAMES.MEET],
  },
  {
    key: PROFILE_MENU_OPTIONS.KOLLAB_STUDIO,
    labelKey: 'profileMenu.kollabStudio',
    icon: 'Star05Icon',
    navigation: { type: 'external', path: '/studio' },
    showOnApps: [APP_NAMES.GOKOLLAB, APP_NAMES.COURSES],
  },
  {
    key: PROFILE_MENU_OPTIONS.MANAGE_PAYMENTS,
    labelKey: 'profileMenu.managePayments',
    icon: 'CreditCard01Icon',
    navigation: {
      type: 'external',
      path: '/payments-integration',
    },
    showOnApps: [APP_NAMES.GOKOLLAB, APP_NAMES.COURSES],
  },
  {
    key: PROFILE_MENU_OPTIONS.AFFILIATES,
    labelKey: 'profileMenu.affiliates',
    icon: 'Users01Icon',
    navigation: { type: 'external', path: '/affiliates' },
    showOnApps: [APP_NAMES.GOKOLLAB, APP_NAMES.COURSES],
  },
]
